import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { WorkItemFormWrapper } from "WorkItemsHub/Scripts/WorkItemFormWrapper";

export interface IWorkItemFormWrapperProps {
    pageContext: any;
    container: any;
    workItemType: string;
    workItemId: number;
}

// This is a proxy component to load full page workitem form using LegacyComponent
class WorkItemPageProxy extends React.Component<IWorkItemFormWrapperProps, {}> {
    private _workItemFormWrapper: WorkItemFormWrapper;

    public render(): React.ReactNode {
        return <div className="workitem-view-content" ref={this.onContainer} />;
    }

    private onContainer = () => {
        // if workitem type is present, open the form in create mode else in edit mode
        if (this.props.workItemType) {
            this._workItemFormWrapper = WorkItemFormWrapper.createForNew(this.props.pageContext, this.props.container, this.props.workItemType);
        } else {
            this._workItemFormWrapper = WorkItemFormWrapper.createForView(this.props.pageContext, this.props.container, this.props.workItemId);
        }
    }
}

registerLWPComponent("workitem-page-proxy", WorkItemPageProxy);
